define([
	"csi/types"
], function(types) {

	return {
		_addNumberFormatting: function(chart, format) {
			// summary: add number formatting parameters to chart based on given format
			if (format) {
				var n = format.indexOf(".");

				if (n >= 0) {
					// if there is a 0 after the decimal place, then force decimals
					if (format[n + 1] == "0") {
						chart.forceDecimals = "1";
					}

					// specify how many decimals
					chart.decimals = format.length - n - 1;
				} else {
					// Fusion charts not forcing this decimals. If number is integer it will not show decimals (unless rounding)
					// In case of rounding, we do want to see decimals even for formats without ".", because otherwise we have problem with rounded numbers
					chart.decimals = 2;
				}

				// find prefix
				var matches = /^(.*?)(#|0)/.exec(format);
				chart.numberPrefix = (matches && matches[1]) || "";
				if (chart.decimals && chart.numberPrefix) {
					chart.decimals--;
				}

				// find suffix
				matches = /(.*)(0|#)(.*?)$/.exec(format);
				chart.numberSuffix = (matches && matches[3]) || "";
				if (chart.decimals && chart.numberSuffix) {
					chart.decimals--;
				}
			} else {
				// restrict number to default
				chart.decimals = types.getDefaultNumberOfDecimals();
			}
		},

		_formatPercentage: function(/*Array*/data, /*string*/format) {
			// row data for percentage is always a fraction of 1, in order to show %% multiply it by 100.
			if (format && (format.indexOf('%') >= 0)) {
				for (var i = 0; i < data.length; i++) {
					if (Array.isArray(data[i])) {
						for (var j = 0; j < data[i].length; j++) {
							data[i][j] = data[i][j] * 100.0;
						}
					} else {
						data[i] = data[i] * 100.0;
					}
				}
			}
		}
	};
});